<div class="image-container"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <img [src]="src"
    [alt]="alt">
  <div class="star"
    *ngFor="let star of stars"
    [ngClass]="star.class"
    [ngStyle]="star.style"></div>
</div>